var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizes_carousel"},[_c('div',{staticClass:"swiper swiper_prizes_carousel"},[_c('div',{staticClass:"swiper-wrapper owl-carousel"},_vm._l((_vm.newArray),function(prize){return _c('div',{key:prize.type,staticClass:"swiper-slide"},[_c('div',{staticClass:"carousel_prize_container"},[_c('img',{attrs:{"src":prize.imgUrl,"alt":""}}),_vm._v(" "),_c('h1',[_vm._v(" "+_vm._s(prize.headline)+" ")])])])}))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4596ab4b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrizeCarousel.vue
// module id = null
// module chunks = 